import { useCallback, useRef } from 'react';

/**
 * 用于检测视频是否完成一次循环播放的自定义Hook
 * 适用于用户不能手动往前拖动进度条的场景
 * @param onComplete 完成一次循环播放后的回调函数
 * @returns 用于绑定到video元素的事件处理函数
 */
export const useVideoCompletion = (onComplete: () => void) => {
  const lastTimeRef = useRef<number>(0);

  // 处理视频时间更新事件
  const handleTimeUpdate = useCallback(
    (event: React.SyntheticEvent<HTMLVideoElement>) => {
      const video = event.currentTarget;
      const currentTime = video.currentTime;

      // 如果当前时间小于上一次记录的时间，则认为视频已经完成一次循环播放
      if (currentTime < lastTimeRef.current) {
        onComplete();
      }

      lastTimeRef.current = currentTime;
    },
    [onComplete],
  );

  return {
    handleTimeUpdate,
  };
};
